/* Zakumi Hero — chrome cross in plain Three.js (no R3F).
   Mirrors src/components/Hero3D.tsx visually. */
(function () {
  const canvas = document.querySelector('[data-zk-hero-canvas]');
  if (!canvas || typeof THREE === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const container = canvas.parentElement;

  /* Renderer */
  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;

  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x0a0a0c);
  scene.fog = new THREE.Fog(0x0a0a0c, 7, 18);

  const camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
  camera.position.set(0, 0, 6.5);

  /* Environment for chrome reflections — RoomEnvironment via PMREM */
  let envTexture = null;
  try {
    const pmrem = new THREE.PMREMGenerator(renderer);
    if (THREE.RoomEnvironment) {
      envTexture = pmrem.fromScene(new THREE.RoomEnvironment(renderer), 0.04).texture;
      scene.environment = envTexture;
    }
  } catch (e) { /* fallback: no env */ }

  /* Lights */
  scene.add(new THREE.AmbientLight(0xffffff, 0.25));
  const dir1 = new THREE.DirectionalLight(0xffffff, 2.6); dir1.position.set(6, 8, 5); scene.add(dir1);
  const dir2 = new THREE.DirectionalLight(0xa8b8d8, 1.3); dir2.position.set(-6, -3, -4); scene.add(dir2);
  const p1 = new THREE.PointLight(0xffffff, 1, 20); p1.position.set(0, 0, 5); scene.add(p1);
  const p2 = new THREE.PointLight(0xe8d8b0, 0.8, 20); p2.position.set(0, -4, 2); scene.add(p2);
  const p3 = new THREE.PointLight(0xffd9a8, 0.6, 20); p3.position.set(3, 3, 3); scene.add(p3);

  /* Cross arm geometry — rounded rectangle with bevel */
  function makeArm(length, width, depth) {
    const w = width / 2, l = length / 2, r = w * 0.15;
    const shape = new THREE.Shape();
    shape.moveTo(-w + r, -l);
    shape.lineTo(w - r, -l);
    shape.quadraticCurveTo(w, -l, w, -l + r);
    shape.lineTo(w, l - r);
    shape.quadraticCurveTo(w, l, w - r, l);
    shape.lineTo(-w + r, l);
    shape.quadraticCurveTo(-w, l, -w, l - r);
    shape.lineTo(-w, -l + r);
    shape.quadraticCurveTo(-w, -l, -w + r, -l);
    shape.closePath();
    const geo = new THREE.ExtrudeGeometry(shape, { depth, bevelEnabled: true, bevelThickness: depth * 0.4, bevelSize: width * 0.12, bevelSegments: 8, curveSegments: 8 });
    geo.center();
    return geo;
  }

  const chromeMat = new THREE.MeshStandardMaterial({ color: 0xffffff, metalness: 0.2, roughness: 0.35, emissive: 0xffffff, emissiveIntensity: 0.55, envMapIntensity: 1.2 });

  const crossGroup = new THREE.Group();
  const vertical = new THREE.Mesh(makeArm(4.2, 0.6, 0.34), chromeMat);
  crossGroup.add(vertical);
  const horizontal = new THREE.Mesh(makeArm(2.4, 0.6, 0.34), chromeMat);
  horizontal.rotation.z = Math.PI / 2;
  horizontal.position.y = 0.7;
  crossGroup.add(horizontal);

  /* Glass jewel approximation (no MeshTransmissionMaterial — use physical material with transmission) */
  const jewelMat = new THREE.MeshPhysicalMaterial({
    color: 0xffffff, metalness: 0, roughness: 0,
    transmission: 1, ior: 1.5, thickness: 0.8,
    clearcoat: 1, clearcoatRoughness: 0,
    envMapIntensity: 1.5
  });
  const jewel = new THREE.Mesh(new THREE.SphereGeometry(0.28, 32, 32), jewelMat);
  jewel.position.set(0, 0.7, 0.18);
  crossGroup.add(jewel);

  /* Inner glow ring */
  const ringMat = new THREE.MeshStandardMaterial({ color: 0xffffff, emissive: 0xffffff, emissiveIntensity: 0.6, metalness: 0.5, roughness: 0.2 });
  const ring = new THREE.Mesh(new THREE.TorusGeometry(0.5, 0.016, 16, 80), ringMat);
  ring.position.y = 0.7;
  crossGroup.add(ring);

  /* Outer halos */
  const haloMat1 = new THREE.MeshStandardMaterial({ color: 0xbfc4ce, metalness: 1, roughness: 0.25, transparent: true, opacity: 0.45 });
  const halo1 = new THREE.Mesh(new THREE.TorusGeometry(2, 0.014, 16, 120), haloMat1);
  halo1.rotation.x = Math.PI / 2;
  halo1.position.z = -0.6;
  crossGroup.add(halo1);

  const haloMat2 = new THREE.MeshStandardMaterial({ color: 0xdcdce4, metalness: 1, roughness: 0.2, transparent: true, opacity: 0.3 });
  const halo2 = new THREE.Mesh(new THREE.TorusGeometry(2.4, 0.008, 16, 120), haloMat2);
  halo2.position.z = -0.6;
  crossGroup.add(halo2);

  scene.add(crossGroup);

  /* Particles */
  const pCount = 350;
  const pPositions = new Float32Array(pCount * 3);
  for (let i = 0; i < pCount; i++) {
    const r = 3 + Math.random() * 7;
    const theta = Math.random() * Math.PI * 2;
    const phi = (Math.random() - 0.5) * Math.PI * 0.7;
    pPositions[i * 3] = Math.cos(theta) * Math.cos(phi) * r;
    pPositions[i * 3 + 1] = Math.sin(phi) * r * 0.9;
    pPositions[i * 3 + 2] = Math.sin(theta) * Math.cos(phi) * r - 2;
  }
  const pGeo = new THREE.BufferGeometry();
  pGeo.setAttribute('position', new THREE.BufferAttribute(pPositions, 3));
  const pMat = new THREE.PointsMaterial({ size: 0.028, color: 0xe8e8f0, transparent: true, opacity: 0.6, sizeAttenuation: true, depthWrite: false });
  const points = new THREE.Points(pGeo, pMat);
  scene.add(points);

  /* Light shafts */
  const shaftGroup = new THREE.Group();
  shaftGroup.position.z = -2.5;
  for (let i = 0; i < 8; i++) {
    const m = new THREE.Mesh(
      new THREE.PlaneGeometry(0.5, 16),
      new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.05, depthWrite: false, side: THREE.DoubleSide })
    );
    m.rotation.z = (i / 8) * Math.PI * 2;
    shaftGroup.add(m);
  }
  scene.add(shaftGroup);

  /* Resize */
  function resize() {
    const w = container.clientWidth, h = container.clientHeight;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }
  resize();
  const ro = new ResizeObserver(resize);
  ro.observe(container);

  /* Animate */
  const clock = new THREE.Clock();
  let baseY = 0;
  function tick() {
    const dt = clock.getDelta();
    const t = clock.getElapsedTime();
    crossGroup.rotation.y += dt * 0.5;
    crossGroup.rotation.x = Math.sin(t * 0.45) * 0.22;
    crossGroup.rotation.z = Math.cos(t * 0.3) * 0.08;
    /* Float */
    crossGroup.position.y = Math.sin(t * 1.4) * 0.15;
    points.rotation.y = t * 0.03;
    points.rotation.x = Math.sin(t * 0.1) * 0.1;
    shaftGroup.rotation.z = t * 0.07;
    renderer.render(scene, camera);
    requestAnimationFrame(tick);
  }

  /* Pause when off-screen */
  let visible = true;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
    }, { threshold: 0 }).observe(canvas);
  }
  function loop() {
    if (visible) tick();
    else requestAnimationFrame(loop);
  }
  tick();
})();
